import TrendDistribution from './TrendDistribution.container';

export default TrendDistribution;
